import { Component, OnInit } from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ProvidersService} from '../../services/providers.service';
import {AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-provider-caller-id-update',
  templateUrl: './provider-caller-id-update.component.html',
  styleUrls: ['./provider-caller-id-update.component.scss']
})
export class ProviderCallerIdUpdateComponent extends ModalExtended implements OnInit {

    formData: FormGroup;
    data: Object;

    isExtraValid: boolean = true;
    submitted: boolean = false;
    loading: boolean = false;

    constructor(private fb: FormBuilder, private providerService: ProvidersService, private alertaService: AlertaService) {
        super();

        this.formData = this.fb.group({
            'phone_caller_id_pk' : new FormControl('', Validators.required),
            'tech_prefix' : new FormControl(),
            'prefix' : new FormControl(),
            'timeout' : new FormControl('', [Validators.required, Validators.pattern('[0-9]*')]),
            'remove_digits' : new FormControl('', [Validators.required, Validators.pattern('[0-9]{1}')]),
            'parameters' : new FormControl('', Validators.required),
            'extra' : new FormControl(),
            'active' : new FormControl('0')
        })
    }

    closeModal(): void  {
        this.close();
        this.applyCallback(true);
    }

    saveProviderCallerIdConfig(): void {

        if(!this.formData.valid || !this.isExtraValid){
            this.submitted = true;
            return;
        }

        this.loading = true;
        this
            .providerService
            .postCallerIdConfig(this.data['provider_pk'], this.formData.value)
            .subscribe(
                (r) => {
                    this.loading = false;
                    this.alertaService.addAlert('success', 'Config for caller id has been created successfully');
                }
            )
    }

    updateProviderCallerIdConfig(): void {
        if(!this.formData.valid || !this.isExtraValid){
            this.submitted = true;
            return;
        }

        this.loading = true;
        this
            .providerService
            .putCallerIdConfig(this.data['object']['pk'], this.formData.value)
            .subscribe(
                (r) => {
                    this.loading = false;
                    this.alertaService.addAlert('success', 'Config for caller id has been updated successfully');
                }
            )
    }

    checkExtra(event: any): void {
        this.isExtraValid = event;
    }

    ngOnInit() {
        if(this.data.hasOwnProperty('object')){
            this.formData.controls['phone_caller_id_pk'].setValue(this.data['object']['phone_caller_id_pk']);
            this.formData.controls['tech_prefix'].setValue(this.data['object']['tech_prefix']);
            this.formData.controls['prefix'].setValue(this.data['object']['prefix']);
            this.formData.controls['timeout'].setValue(this.data['object']['timeout']);
            this.formData.controls['remove_digits'].setValue(this.data['object']['remove_digits']);
            this.formData.controls['parameters'].setValue(this.data['object']['parameters']);
            this.formData.controls['extra'].setValue(this.data['object']['extra']);
            this.formData.controls['active'].setValue(this.data['object']['active']);
        }
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/providers/modals/provider-caller-id-update/provider-caller-id-update.component.ts